import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../constants/logging';
import { apiClientWithMiddleware } from '../utils/API';
import { queryRawLocalStorage, removeLocalStorage, setRawLocalStorage } from '../utils/localstorage';
const hubTrialsEndpoint = '/trials/v1/hub-trials/app/name/all';
const defaultResponse = [];
const MIGRATION_CACHE_DURATION = 10 * 60 * 1000; // 10 minutes
const MIGRATION_CACHE_KEY = 'hubspot_trials_migration_timestamp';
const isMigrationInProgress = () => {
  const timestampStr = queryRawLocalStorage(MIGRATION_CACHE_KEY);
  if (!timestampStr) {
    return false;
  }
  const migrationTimestamp = Number(timestampStr);
  if (isNaN(migrationTimestamp)) {
    removeLocalStorage(MIGRATION_CACHE_KEY);
    return false;
  }
  const timeSinceMigration = Date.now() - migrationTimestamp;
  if (timeSinceMigration > MIGRATION_CACHE_DURATION) {
    removeLocalStorage(MIGRATION_CACHE_KEY);
    return false;
  }
  return true;
};
export const getCurrentTrials = async portalId => {
  if (isMigrationInProgress()) {
    return defaultResponse;
  }
  try {
    return await apiClientWithMiddleware().get(hubTrialsEndpoint, {
      query: {
        portalId
      }
    });
  } catch (error) {
    const requestError = error;
    const status = Number(requestError.status);
    if (status === 477) {
      setRawLocalStorage(MIGRATION_CACHE_KEY, Date.now().toString());
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.debug(`Portal ${portalId} is mid-migration (status 477). Caching to prevent repeat calls.`, {
        portalId,
        status: requestError.status,
        endpoint: hubTrialsEndpoint
      });
    }
    return defaultResponse;
  }
};